import { Skeleton } from "@mui/material";
import { SkeletonBody, SkeletonCardWrapper, SkeletonItems } from "./ReviewTruckDetailsSkeleton.styles";

const ReviewTruckDetailsSkeleton = () => {
	return (
		<SkeletonCardWrapper
			elevation={1}
			square
		>
			<Skeleton
				variant="text"
				width="10%"
				height={30}
			/>
			<SkeletonBody>
				<SkeletonItems>
					<Skeleton
						variant="text"
						width="10%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="30%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="10%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="10%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="30%"
						height={30}
					/>
				</SkeletonItems>
				<SkeletonItems>
					<Skeleton
						variant="text"
						width="10%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="30%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="10%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="10%"
						height={30}
					/>
					<Skeleton
						variant="text"
						width="30%"
						height={30}
					/>
				</SkeletonItems>
			</SkeletonBody>
			<Skeleton
				variant="text"
				width="42.5%"
				height={30}
			/>
		</SkeletonCardWrapper>
	);
};

export default ReviewTruckDetailsSkeleton;
